import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesAvailable',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { isAlive: true, logicalId: 'physical' },
      status: 'available',
    },
  };
};
const DevicesAvailable = props => {
  const defaultProps = {
    title: 'Available devices',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesAvailable;
